import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const sendFinalPDF = (data) => {

    return axios.post(api.SEND_FINAL_PDF, data)
      .then((response) => {
        const {errorCode} = response.data;
        if (errorCode < 0) throw new Error(E.SERVER_ERROR);
      })
};
